import { Skeleton as UISkeleton } from "components/ui/skeleton";
import { cn } from "utils";

export function Skeleton({
  animated = true,
  className,
  ...props
}: React.ComponentProps<"div"> & { animated?: boolean }) {
  return (
    <UISkeleton
      className={cn(!animated && "animate-none", className)}
      {...props}
    />
  );
}
